import type { TFunction } from 'i18next';
import { SourceStatus } from '@/types/source';

export function isSourceCardNavigationEnabled(
    status: SourceStatus | undefined,
): boolean {
    return (
        status !== SourceStatus.UPLOADING &&
        status !== SourceStatus.PENDING &&
        status !== SourceStatus.FIXING
    );
}

export function isAnalyzingSourceStatus(status: SourceStatus): boolean {
    return (
        status === SourceStatus.UPLOADING ||
        status === SourceStatus.PENDING ||
        status === SourceStatus.QUEUED ||
        status === SourceStatus.PROCESSING ||
        status === SourceStatus.FIXING
    );
}

export function isAnalyzingPhaseSourceStatus(status: SourceStatus): boolean {
    return (
        status === SourceStatus.UPLOADING ||
        status === SourceStatus.PROCESSING ||
        status === SourceStatus.FIXING
    );
}

export function getSourceStatusLabel(
    status: SourceStatus,
    translate: TFunction,
): string {
    switch (status) {
        case SourceStatus.COMPLETED:
            return translate('status.ready');
        case SourceStatus.PENDING:
            return translate('status.pending');
        case SourceStatus.QUEUED:
            return translate('status.queued');
        case SourceStatus.FIXING:
            return translate('status.fixing');
        case SourceStatus.UPLOADING:
            return translate('card.generatingPreview');
        case SourceStatus.PROCESSING:
            return translate('status.analyzing');
        case SourceStatus.ERROR:
            return translate('status.error');
        default:
            return translate('status.analyzing');
    }
}
